import * as actionTypes from "../actionTypes";

const initialState = {
    bannerData: [],
};

const bannerReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_BANNER: {
            return {
                ...state,
                bannerData: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default bannerReducer;
